import MuiAvatar from './MuiAvatar';
import MuiTableCell from './MuiTableCell';
import MuiListItemIcon from './MuiListItemIcon';
import MuiInputBase from './MuiInputBase';
import MuiTabs from './MuiTabs';
import MuiExpansionPanel from './MuiExpansionPanel';
import MuiLink from './MuiLink';
import MuiTypography from './MuiTypography';

export default {
  MuiAvatar,
  MuiTableCell,
  MuiListItemIcon,
  MuiTabs,
  MuiExpansionPanel,
  MuiLink,
  MuiTypography,
  MuiInputBase,
};
